import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=53896b96&scoped=true&"
import script from "./CompanyInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=53896b96&lang=scss&scoped=true&"
import style1 from "./CompanyInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53896b96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53896b96')) {
      api.createRecord('53896b96', component.options)
    } else {
      api.reload('53896b96', component.options)
    }
    module.hot.accept("./CompanyInfo.vue?vue&type=template&id=53896b96&scoped=true&", function () {
      api.rerender('53896b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/CompanyInfo.vue"
export default component.exports